import * as React from 'react';
import './AllocatedWPPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { IAllocatedWPReduxFormState, initialAllocatedWPState } from "../../../reducers/reactReduxForms/allocatedWP";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput } from "../../../components/form/index";
import * as AllocatedWPActions from '../../../actions/allocatedWPs';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { TrialLookupsLayout } from '../../index';
import * as AuthenticationHelper from '../../../helpers/authentication';

interface IAllocatedWPPageParams {
    allocatedWPId: number;
}

interface IAllocatedWPPageProps {

    form: Dtos.AllocatedWP & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IAllocatedWPReduxFormState;

    location: Location;
    allocatedWPId: number;
    match: match<IAllocatedWPPageParams>;
    history: History;

    // From state
    allocatedWP: Dtos.AllocatedWP;
    lookups: Dtos.Lookup[];

    loadingAllocatedWP: boolean;
    loadAllocatedWPSuccess: boolean;
    loadAllocatedWPFailure: boolean;

    savingAllocatedWP: boolean;
    saveAllocatedWPSuccess: boolean;
    saveAllocatedWPFailure: boolean;

    creatingAllocatedWP: boolean;
    createAllocatedWPSuccess: boolean;
    createAllocatedWPFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface IAllocatedWPPageActions {
    clearAllocatedWP: AllocatedWPActions.IAllocatedWPClearActionCreator;
    loadAllocatedWP: AllocatedWPActions.IAllocatedWPLoadByIdActionCreator;

    saveAllocatedWP: AllocatedWPActions.IAllocatedWPSaveActionCreator;
    createAllocatedWP: AllocatedWPActions.IAllocatedWPCreateActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type AllocatedWPPageProps = IAllocatedWPPageProps & IAllocatedWPPageActions;

const reduxFormName: string = "reduxForms.allocatedWP";

class AllocatedWPPage extends React.PureComponent<AllocatedWPPageProps, any> {

    constructor(props: AllocatedWPPageProps) {
        super(props);

        this.clearAllocatedWP = this.clearAllocatedWP.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadAllocatedWP,
            allocatedWPId,
            createAllocatedWP
        } = this.props;

        if (allocatedWPId) {
            loadAllocatedWP(allocatedWPId);
        } else if (!allocatedWPId) {
            createAllocatedWP();
        }
    }

    componentWillReceiveProps(nextProps: AllocatedWPPageProps) {
    }

    componentDidUpdate(prevProps: AllocatedWPPageProps, prevState) {
        const {
            allocatedWPId,
            allocatedWP,
            form,
            navigate,
            loadAllocatedWP,
            loadingAllocatedWP,
            loadAllocatedWPSuccess,
            createAllocatedWP,
            creatingAllocatedWP,
            createAllocatedWPSuccess,
            savingAllocatedWP,
            saveAllocatedWPSuccess,
            validationFailures
        } = this.props;

        if (allocatedWPId && prevProps.allocatedWPId != allocatedWPId) {
            loadAllocatedWP(allocatedWPId);
        }
        else if (!allocatedWPId && prevProps.allocatedWPId) {
            createAllocatedWP();
        }

        if (!loadingAllocatedWP && prevProps.loadingAllocatedWP) {
            if (loadAllocatedWPSuccess) {
                this.loadForm();
            }
        }

        if (!savingAllocatedWP && prevProps.savingAllocatedWP) {
            if (saveAllocatedWPSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                } else {
                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);
                }
                if (form.saveAndReturn) {
                    navigate("/settings/trial/allocatedwps")
                } else if (!form.saveAndReturn && allocatedWPId && allocatedWPId > 0) {
                    this.loadForm();
                } else if (!form.saveAndReturn && !allocatedWPId && allocatedWP && allocatedWP.id > 0) {
                    navigate("/settings/trial/allocatedwps/" + allocatedWP.id);
                }
            }
            else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingAllocatedWP && prevProps.creatingAllocatedWP) {
            if (createAllocatedWPSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUpdate(nextProps: AllocatedWPPageProps) {
    }

    componentWillUnmount() {
        const {
            resetForm,
            loadForm
        } = this.props

        this.clearAllocatedWP();
        loadForm(reduxFormName, initialAllocatedWPState);
        resetForm(reduxFormName);
    }

    clearAllocatedWP() {
        this.props.clearAllocatedWP();
    }

    showAllocatedWP(): boolean {
        const {
            loadingAllocatedWP,
            loadAllocatedWPSuccess
        } = this.props

        if (!loadingAllocatedWP && loadAllocatedWPSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingAllocatedWP
        } = this.props;

        return <TrialLookupsLayout loading={loadingAllocatedWP} permission={Dtos.Permission.AllocatedWPsView}>
            {this.renderContent()}
        </TrialLookupsLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingAllocatedWP,
            permissions
        } = this.props;

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.AllocatedWPsUpdate, Dtos.Permission.AllocatedWPsCreate);
        const formDisabled: boolean = !hasPermission || savingAllocatedWP || (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            value: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            rank: {
                type: RegistrationComponent.RegistrationControl,
                inputType: NumberFormInput,
                inputDisabled: formDisabled,
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active"
                },
                inputLabel: " ",
            }
        };

        return <div>
            <h1>Allocated WP</h1>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "allocatedWP", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>

        </div>

    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
            </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.AllocatedWP) {
        const {
            saveAllocatedWP
        } = this.props;

        if (data) {
            let changes: Dtos.AllocatedWP = {} as Dtos.AllocatedWP;
            saveAllocatedWP(Object.assign({ ...data }, changes));
        }
    }


    handleOnSubmitFailed(data: Dtos.AllocatedWP) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            navigate
        } = this.props;

        navigate("/settings/trial/allocatedwps");
    }

    loadForm() {
        const {
            loadForm,
            allocatedWP,
        } = this.props

        let extraData: Dtos.AllocatedWP = {} as Dtos.AllocatedWP;

        loadForm(reduxFormName, Object.assign({ ...allocatedWP }, extraData));
    }

}


const mapStateToProps = (state: ITmdState, ownProps: AllocatedWPPageProps): IAllocatedWPPageProps => {

    let allocatedWP: Dtos.AllocatedWP | undefined = !(state.allocatedWPs.formData instanceof Array) ? state.allocatedWPs.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        allocatedWPId: ownProps.match && ownProps.match.params.allocatedWPId && ownProps.match.params.allocatedWPId.toString() != "create" ? ownProps.match.params.allocatedWPId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        allocatedWP: allocatedWP!,

        loadingAllocatedWP: state.allocatedWPs.loadState && state.allocatedWPs.loadState.status == RequestState.Pending,
        loadAllocatedWPSuccess: state.allocatedWPs.loadState && state.allocatedWPs.loadState.status == RequestState.Success,
        loadAllocatedWPFailure: state.allocatedWPs.loadState && state.allocatedWPs.loadState.status == RequestState.Failure,

        savingAllocatedWP: state.allocatedWPs.saveState && state.allocatedWPs.saveState.status == RequestState.Pending,
        saveAllocatedWPSuccess: state.allocatedWPs.saveState && state.allocatedWPs.saveState.status == RequestState.Success,
        saveAllocatedWPFailure: state.allocatedWPs.saveState && state.allocatedWPs.saveState.status == RequestState.Failure,

        creatingAllocatedWP: state.allocatedWPs.createState && state.allocatedWPs.createState.status == RequestState.Pending,
        createAllocatedWPSuccess: state.allocatedWPs.createState && state.allocatedWPs.createState.status == RequestState.Success,
        createAllocatedWPFailure: state.allocatedWPs.createState && state.allocatedWPs.createState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        lookups: [],

        form: state.reduxForms.allocatedWP,
        formState: state.allocatedWPs.formState,
        formProperties: state.allocatedWPs.formProperties,

        reduxFormState: state.reduxForms.formState.allocatedWP,
        validationFailures: allocatedWP ?
            state.allocatedWPs.validationFailures :
            undefined,
    };
};

const mapDispatchToProps = (dispatch): IAllocatedWPPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadAllocatedWP: bindActionCreators(AllocatedWPActions.LoadAllocatedWPById, dispatch),
        clearAllocatedWP: bindActionCreators(AllocatedWPActions.Clear, dispatch),

        saveAllocatedWP: bindActionCreators(AllocatedWPActions.SaveAllocatedWP, dispatch),
        createAllocatedWP: bindActionCreators(AllocatedWPActions.CreateAllocatedWP, dispatch),

    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(AllocatedWPPage);
